import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { showOrderPartsHelpAction } from '@app/react/action/showOrderPartsHelp';
import { fetchFamilyCrestList } from '@app/react/action/FetchFamilyCrestList';
import {
    GetResponseOrderParts,
    AsyncGeneralState,
} from '@app/react/const/type';
import { ORDER_PARTS } from '@app/react/const/variables';

export interface OrderPartsHelpeUIReducer {
    opened: typeof ORDER_PARTS[number] | null;
    fcLoadState: AsyncGeneralState;
    fcLoadErr: string | null;
    familycrestList: GetResponseOrderParts | null;
}

const initState: OrderPartsHelpeUIReducer = {
    opened: null,
    fcLoadState: 'init',
    fcLoadErr: null,
    familycrestList: null,
};

export const orderPartsHelpeUIReducer = reducerWithInitialState(initState)
    .case(showOrderPartsHelpAction, (state, { partsName }) => ({
        ...state,
        opened: partsName,
    }))
    .case(fetchFamilyCrestList.started, (state) => ({
        ...state,
        fcLoadState: 'request',
        familycrestList: null,
    }))
    .case(fetchFamilyCrestList.done, (state, action) => ({
        ...state,
        fcLoadState: 'done',
        fcLoadErr: null,
        familycrestList: action.result.items,
    }))
    .case(fetchFamilyCrestList.failed, (state) => ({
        ...state,
        fcLoadState: 'error',
        fcLoadErr: '家紋一覧の取得に失敗しました', // convert to ui error
        familycrestList: null,
    }));
